export default __webpack_public_path__ + "static/media/easter_island.fbae1c1a.svg";